import { render, staticRenderFns } from "./UpcomingAwardsTable.vue?vue&type=template&id=7da02108&scoped=true&"
import script from "./UpcomingAwardsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./UpcomingAwardsTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UpcomingAwardsTable.vue?vue&type=style&index=0&id=7da02108&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da02108",
  null
  
)

export default component.exports